<owl-carousel-o #carousel [options]="customOptions">
  <ng-container *ngFor="let profile of profiles; let i = index">
    <ng-template carouselSlide>
      <div class="item_s">
        <img [src]="profile.image" [alt]="profile.name">
        <div *ngIf="profile.isAddStory" class="add-story-icon">
          <a href="#" data-bs-toggle="modal" data-bs-target="#create_modal-story">+</a>
        </div>
        <p>{{ profile.name }}</p>
      </div>
      <!-- model -->
      
    </ng-template>
  </ng-container>
</owl-carousel-o>
